export enum StorageClassifier {
  /*
  Data classifier values used with this classifier are persisted and not deleted
  */
  DATA = 'data',
  /*
  Data stored with this classifier are delete in sign out
  */
  TEMPORAL = 'temporal',
  /*
  Data stored with this classifier are delete in sign out, represent filters data
  */
  FILTER = 'filter',
  /**
   * Data classifier used to persist all filters
   */
  PERSISTENT_FILTER = 'persistentFilter',
}
